import util from '../../lib/util';
import store from '../../store/store';
import TemplateTask from "../../entities/templateTask";
import Task from "../../entities/task";

/**
 * We always pass the current template to ensure the data is fresh
 * @param {TemplateTask} [template]
 * @returns {TemplateTask[]}
 * @private
 */
function _getTemplateTasks(template: TemplateTask) {
    const allButTemplate = store.getState()
                                .templateTasks
                                .filter(util.deletedFilter)
                                .filter(tt => tt.global)
                                .filter(tt => tt.id !== template?.id);

    if (template) return [template, ...allButTemplate];
    else return allButTemplate;
}

// Commented out until we get the process logic going.
//
// /**
//  * Get all sources for an given templateTask.
//  *
//  * @param template
//  * @return {TemplateTask[]}
//  */
// export function getCurrentSources(template) {
//     return _getTemplateTasks(template).filter(tt => template.sources.includes(tt.id));
// }
//
// /**
//  * Get all possible sources for the template.  This includes all templateTasks except
//  * for the template itself and it's current targets.
//  *
//  * @param {TemplateTask} template
//  * @return {TemplateTask[]}
//  */
// export function getPossibleSources(template) {
//     const targets = [];
//     const getRecursiveTargets = (t) => getCurrentTargets(t)
//         .forEach(tt => {
//             targets.push(tt.id);
//
//             getRecursiveTargets(tt);
//         });
//
//     getRecursiveTargets(template);
//
//     return _getTemplateTasks(template).filter(tt => (tt.id !== template.id) && !targets.includes(tt.id));
// }
//
// /**
//  * Get the targets for the given templateTask.
//  *
//  * @param {TemplateTask} template
//  * @return {TemplateTask[]}
//  */
// export function getCurrentTargets(template) {
//     return _getTemplateTasks(template).filter(tt => template.targets.includes(tt.id));
// }
//
// /**
//  * Get all possible targets for the given template.  This will include any all templateTasks
//  * except for the template itself and it's sources (and sources' sources, ad infinitum) and targets (and targets' targets).
//  *
//  * @param {TemplateTask} template
//  * @return {TemplateTask[]}
//  */
// export function getPossibleTargets(template) {
//     const sources = [];
//     const getRecursiveSources = (t) => getCurrentSources(t)
//         .forEach(tt => {
//             sources.push(tt.id);
//
//             getRecursiveSources(tt);
//         });
//
//     getRecursiveSources(template);
//
//     const targets = [];
//     const getRecursiveTargets = (t) => getCurrentTargets(t)
//         .forEach(tt => {
//             targets.push(tt.id);
//
//             getRecursiveTargets(tt);
//         });
//
//     getRecursiveTargets(template);
//
//     return _getTemplateTasks(template).filter(tt => (tt.id !== template.id) && !sources.includes(tt.id) && !targets.includes(tt.id));
// }

/**
 *
 * @param {Task} task
 * @return {TemplateTask}
 */
export function getSource(task: Task): TemplateTask {
    return store.getState()
                .templateTasks
                .getIndex('notDeleted')
                .find(tt => tt.id === task.fromTemplateId);
}